<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <cloud-table-component
          :columns="columns"
          :rows="records"
          :sortable="sortable"
          :pagination="pagination"
          @sorting="sorting"
          @pageChanged="pageChanged"
        >

          <template v-slot:total_amount="{ row }">
            <div>{{ formatPrice(row.total_amount) }}</div>
          </template>
          <template v-slot:payment_method="{ row }">
            <div class="custom-td-w">{{ row?.payment_method?.name }}</div>
          </template>
        </cloud-table-component>
      </div>
    </div>
  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import {mapGetters} from "vuex";

export default {
  name: "InvoicePaymentHistory",
  components: {CloudTableComponent},
  props: ['invoiceid'],
  data() {
    return {
      records: [],
      filter: {
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,cloudServer.server_name,status',
        sort: 'invoice_date',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Invoice",
          field: "invoice_number",
        },
        {
          label: "Amount",
          field: "total_amount",
          sortable: false,
          slot: true,
        },
        {
          label: "Invoice Date",
          field: "invoice_date",
        },
        {
          label: "Payment By",
          field: "payment_collect",
        },
        {
          label: "Payment Method",
          field: "payment_method",
          slot: true
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
        },
        {
          label: "Process At",
          field: "action_at",
          sortable: true,
        },
        {
          label: "Response",
          field: "comment",
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      editId: null,
      isShowInquiryDetailsModal: false,
      inquiryId: null,
    }
  },
  watch: {
    '$route.query.page': {
      handler(newSlug, oldSlug) {
        if (newSlug !== oldSlug) {
          this.setQueryData(this.getAllQueryParams());
          this.loadData();
        }
      },
    },
    customer() {
      this.loadData();
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    title(){
      return 'Invoice Payment History';
    }
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'invoice_date',
        sort: 'desc'
      }

      this.filter = {
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,cloudServer.server_name,status',
        sort: 'invoice_date',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.lyLoading = true
      let params = { ...this.queryParams, ...this.filter }
      this.axios.get(`/invoice-payment-history/${this.invoiceid}`, {
        params : params
      })
          .then(({data}) => {
            this.records = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    openDetailsInquiry(inquiryId){
      this.inquiryId = inquiryId
      this.isShowInquiryDetailsModal = true
    },
    closeDetailsInquiry(){
      this.inquiryId = null
      this.isShowInquiryDetailsModal = false
    },
  }
}
</script>

<style>
.custom-td-w{
  display: block;
  width: 200px;
  word-break: break-word;
  white-space: normal;
}
</style>